import React from 'react';

import { WidgetType } from '../../../types/WidgetType';
import { useHawkWidgetContext } from '../HawkWidget/HawkWidgetContext';

import styles from './styles/no-deals.css';

const NoDeals: React.FC = () => {
  const { loading, translate, widget } = useHawkWidgetContext();
  const message = ((): string => {
    if (widget.type === WidgetType.COMPARISON) {
      if (loading) {
        return translate('comparisonNoDealsLoading', ['<strong>', '</strong>']);
      }
      return translate('comparisonNoDealsLoaded', ['<strong>', '</strong>']);
    }
    return translate('reviewNoDealsLabel');
  })();
  const className = styles[widget.type] ? widget.type : 'container';

  return (
    <div className={styles[className]}>
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
    </div>
  );
};

export default NoDeals;
